<template>
  <RequestCommentAdded
    request-type="overtime"
    :notification="notification"
    :active-notification="activeNotification"
    @show-more-details="showMoreDetails"
  />
</template>

<script>
import RequestCommentAdded from '@/components/notifications/RequestCommentAdded'
import Notification from '@/components/notifications/mixins/Notification'

export default {
  name: 'OvertimeCommentAdded',

  components: {
    RequestCommentAdded,
  },

  mixins: [Notification],

  methods: {
    showMoreDetails() {
      this.$emit('click', this.notification)
    },
  },
}
</script>
